module.exports = "/images/12meses.svg?5d476190bcde774a81613d05e9007582";